/**
 * Mode clair / sombre : la classe `dark` sur <html> (Tailwind darkMode: 'class').
 * Le choix est gardé dans le navigateur ; sans choix, on suit le réglage du système.
 * Le même calcul tourne avant le rendu dans le <head> de chaque app (pas de flash).
 */
export type Theme = 'light' | 'dark'

const KEY = 'fyrox-theme'

export function currentTheme(): Theme {
    return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

export function applyTheme(theme: Theme, remember = true): void {
    const root = document.documentElement
    root.classList.toggle('dark', theme === 'dark')
    root.style.colorScheme = theme
    if (remember) {
        try {
            localStorage.setItem(KEY, theme)
        } catch {
            // navigation privée : le choix vaut pour la session seulement
        }
    }
}

export function initialTheme(): Theme {
    try {
        const saved = localStorage.getItem(KEY)
        if (saved === 'dark' || saved === 'light') return saved
    } catch {
        // stockage indisponible
    }
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}
